import { StyleSheet } from "react-native";

export default StyleSheet.create({
  mainContainer: {
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },

  imageView: {
    zIndex:-999999,
  },
  imageInfoTip: {
    padding: 5,
    width: 14,
    height: 14,
  },

  infoView: {
    zIndex: 999999,
    position: "absolute",
    marginRight: 10,
    marginTop: 0,
    marginBottom: 20,
    flexDirection: "row",
    alignItems: "flex-end",
  },
  popUpTxt: {
    fontSize: 12,
    //color: "grey",
    textAlign: "left",
    fontFamily: "SFProText",
    fontWeight: "300",
    color: "#273a4e",
  },
  triangleCss: {
    width: "0%",
    height: "0%",
    borderLeftWidth: 15,
    borderRightWidth: 15,
    borderBottomWidth: 30,
    backgroundColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "white",
    marginBottom: -5,
    marginRight: 4,
    marginLeft: -54,
    zIndex: 9999,
  },
  infoViewChild: {
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.34,
    shadowRadius: 7.27,

    elevation: 10,
    backgroundColor: "white",
    margin: 5,
    left: -30,

    borderRadius: 14,
    borderBottomRightRadius: 0,

    fontSize: 15,
    fontStyle: "normal",
    fontWeight: "300",
    color: "white",
    overflow: "visible",
    zIndex: 9999,
    color: "white",
    width: "100%",
    minWidth: 188,
    top: 10,
  },
});
